import { MARKETING_NEWSLETTER_SEND_CHUNK_SIZE } from './marketing-newsletter-send';

/** NFR-P02 reference load — 50k recipients must fan out async (no HTTP hold). */
export const MARKETING_FANOUT_LOAD_TEST_RECIPIENT_COUNT = 50_000;

export function chunkRecipientIds<T>(
  items: readonly T[],
  chunkSize = MARKETING_NEWSLETTER_SEND_CHUNK_SIZE,
): T[][] {
  if (chunkSize < 1) throw new Error('chunkSize must be >= 1');
  const chunks: T[][] = [];
  for (let i = 0; i < items.length; i += chunkSize) {
    chunks.push(items.slice(i, i + chunkSize));
  }
  return chunks;
}

export function estimateFanOutJobCount(
  recipientCount: number,
  chunkSize = MARKETING_NEWSLETTER_SEND_CHUNK_SIZE,
): number {
  if (recipientCount <= 0) return 0;
  return Math.ceil(recipientCount / chunkSize);
}

/** S24 load sim — returns chunk/job counts for soak planning. */
export function simulateMarketingFanOutLoad(input: {
  recipientCount: number;
  chunkSize?: number;
}) {
  const chunkSize = input.chunkSize ?? MARKETING_NEWSLETTER_SEND_CHUNK_SIZE;
  const jobCount = estimateFanOutJobCount(input.recipientCount, chunkSize);
  const ids = Array.from({ length: input.recipientCount }, (_, index) => `r_${index}`);
  const chunks = chunkRecipientIds(ids, chunkSize);
  return {
    recipientCount: input.recipientCount,
    chunkSize,
    jobCount,
    lastChunkSize: chunks.at(-1)?.length ?? 0,
    asyncOnly: true,
  };
}

export const MARKETING_PRODUCTION_SOAK_COPY =
  'S24: enable MARKETING_WARMUP_ACTIVE on staging→prod until IP/domain reputation is established; mail-tester ≥ 9/10 and 7-day soak are ops gates before first production cohort.';
